export const carouselProperties = {
  indexStart: 1,
  indexEnd: 7,
  indexMovement: 3,
  startMinIndex: 5,
  startMaxIndex: 4,
  timeOut: 10,
};
